import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Doctors = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const DOMAIN = process.env.REACT_APP_DOMAIN;
  const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    document.title = "اطبائنا";
    const fetchData = async () => {
      try {
        const response = await fetch(API_URL + "fetch-all-doctors"); // Replace with your API URL
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setItems(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="row g-4">
        <header className="mb-4 text-center">
          <h1 className="display-4">اطبائنا</h1>
          <p className="lead text-muted">
          حسب الترتيب الابجدي
          </p>
        </header>
        {items.map((item, index) => (
          <div className="col-md-4 col-sm-6" key={index}>
            <div className="card h-100">
              <img
                src={"https://aullan.com/doctor_profile_pictures/" + item.profile_picture || "https://via.placeholder.com/150"}
                className="card-img-top"
                alt={item.title}
              />
              <div className="card-body">
                <h5 className="card-title">{item.full_name}</h5>
                <p className="card-text">{item.brief}</p>
              </div>
              <div className="card-footer">
                <a href={DOMAIN + "doctor/" + item.username || "#"} className="btn btn-info">
                  مشاهدة
                </a>
                <a href={DOMAIN + "book/" + item.username || "#"} className="btn btn-warning me-2">
                  حجز
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Doctors;